/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var MassTransitCommonSupportServiceAttachmentDataEncoding;
(function (MassTransitCommonSupportServiceAttachmentDataEncoding) {
    MassTransitCommonSupportServiceAttachmentDataEncoding[MassTransitCommonSupportServiceAttachmentDataEncoding["Unspecified"] = 0] = "Unspecified";
    MassTransitCommonSupportServiceAttachmentDataEncoding[MassTransitCommonSupportServiceAttachmentDataEncoding["PlainText"] = 1] = "PlainText";
    MassTransitCommonSupportServiceAttachmentDataEncoding[MassTransitCommonSupportServiceAttachmentDataEncoding["Base64"] = 2] = "Base64";
    MassTransitCommonSupportServiceAttachmentDataEncoding[MassTransitCommonSupportServiceAttachmentDataEncoding["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(MassTransitCommonSupportServiceAttachmentDataEncoding || (MassTransitCommonSupportServiceAttachmentDataEncoding = {}));
export function instanceOfMassTransitCommonSupportServiceAttachmentDataEncoding(value) {
    for (const key in MassTransitCommonSupportServiceAttachmentDataEncoding) {
        if (Object.prototype.hasOwnProperty.call(MassTransitCommonSupportServiceAttachmentDataEncoding, key)) {
            if (MassTransitCommonSupportServiceAttachmentDataEncoding[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function MassTransitCommonSupportServiceAttachmentDataEncodingFromJSON(json) {
    return MassTransitCommonSupportServiceAttachmentDataEncodingFromJSONTyped(json, false);
}
export function MassTransitCommonSupportServiceAttachmentDataEncodingFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MassTransitCommonSupportServiceAttachmentDataEncodingToJSON(value) {
    return value;
}
export function MassTransitCommonSupportServiceAttachmentDataEncodingToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=MassTransitCommonSupportServiceAttachmentDataEncoding.js.map